<img class="fp-loading rotating" :src="spinner" :style="style">